/**
 * PosterSocial — 1080×1350 portrait poster for Instagram / WhatsApp share.
 * Captured via Playwright at exact dimensions.
 */
import React from "react";
import DharmaWheel from "../components/DharmaWheel";
import { BABASAHEB_IMG } from "../components/BabasahebPortrait";

const SITE_URL = "ambedkaritebuddhistsociety.org";

const HIGHLIGHTS = [
  "Charitable digital platform",
  "Live meditation & Dhamma talks",
  "Education for ages 5–16",
  "Buddha Purnima & Ambedkar Jayanti",
  "Member platform — JaaS meetings",
  "Open to all · UK-wide & global",
];

export default function PosterSocial() {
  return (
    <div
      data-testid="poster-social"
      style={{
        width: 1080,
        height: 1350,
        background: "#001B3A",
        color: "#FDFBF7",
        fontFamily: "'Inter', system-ui, sans-serif",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 18% 18%, rgba(207,160,82,0.22) 0%, transparent 45%), radial-gradient(circle at 86% 92%, rgba(224,122,95,0.18) 0%, transparent 45%)",
        }}
      />
      <div style={{ position: "absolute", right: -180, top: -180, opacity: 0.09 }}>
        <DharmaWheel size={780} color="#CFA052" ringColor="#CFA052" />
      </div>

      {/* TOP IDENTITY */}
      <div style={{ padding: "60px 70px 0", position: "relative", display: "flex", alignItems: "center", gap: 18 }}>
        <DharmaWheel size={56} color="#CFA052" ringColor="#001B3A" />
        <div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 28, lineHeight: 1, fontWeight: 600 }}>
            Ambedkarite Buddhist Global Network UK
          </div>
          <div style={{ fontSize: 11, letterSpacing: "0.28em", color: "#CFA052", marginTop: 6, textTransform: "uppercase", fontWeight: 600 }}>
            Rooted in Dhamma · Inspired by Babasaheb
          </div>
        </div>
      </div>

      {/* HERO */}
      <div style={{ padding: "60px 70px 30px", position: "relative" }}>
        <div style={{ fontSize: 14, letterSpacing: "0.32em", color: "#E07A5F", textTransform: "uppercase", fontWeight: 600 }}>
          CIO Application in Preparation · Now Live
        </div>
        <h1
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: 92,
            lineHeight: 0.96,
            fontWeight: 500,
            margin: "26px 0 0",
            letterSpacing: "-0.01em",
          }}
        >
          A charitable network <span style={{ color: "#CFA052", fontStyle: "italic" }}>for our sangha.</span>
        </h1>
        <p
          style={{
            fontSize: 21,
            lineHeight: 1.5,
            color: "rgba(253,251,247,0.78)",
            margin: "32px 0 0",
            maxWidth: 880,
          }}
        >
          The Ambedkarite Buddhist Global Network UK advances Buddhist education,
          meditation, equality and public community participation through in-person
          activities and our own charitable digital platform.
        </p>
      </div>

      {/* PORTRAIT + HIGHLIGHTS */}
      <div style={{ padding: "20px 70px 0", position: "relative", display: "grid", gridTemplateColumns: "300px 1fr", gap: 38, alignItems: "center" }}>
        <div
          style={{
            border: "1px solid rgba(207,160,82,0.35)",
            borderRadius: 6,
            padding: 14,
            background: "rgba(253,251,247,0.04)",
          }}
        >
          <div style={{ aspectRatio: "4/5", overflow: "hidden", borderRadius: 3, background: "#001B3A" }}>
            <img
              src={BABASAHEB_IMG}
              alt="Babasaheb"
              style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "50% 28%" }}
            />
          </div>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, marginTop: 14, marginBottom: 0, textAlign: "center" }}>
            Babasaheb
          </p>
          <p style={{ fontSize: 9, letterSpacing: "0.2em", color: "#E07A5F", textTransform: "uppercase", margin: 0, textAlign: "center", marginTop: 4 }}>
            1891 — 1956
          </p>
        </div>
        <div>
          <p style={{ fontSize: 12, letterSpacing: "0.32em", color: "#E07A5F", textTransform: "uppercase", fontWeight: 600, marginBottom: 18 }}>
            Inside the website
          </p>
          <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
            {HIGHLIGHTS.map((h) => (
              <li
                key={h}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 14,
                  padding: "10px 0",
                  borderBottom: "1px solid rgba(207,160,82,0.15)",
                  fontSize: 18,
                  lineHeight: 1.35,
                  color: "rgba(253,251,247,0.85)",
                }}
              >
                <span style={{ color: "#CFA052", fontFamily: "'Cormorant Garamond', serif", fontSize: 28, fontWeight: 600, lineHeight: 1 }}>·</span>
                {h}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* QUOTE STRIP */}
      <div style={{ padding: "60px 70px 0", position: "relative" }}>
        <div
          style={{
            padding: "22px 28px",
            background: "rgba(207,160,82,0.12)",
            borderLeft: "4px solid #CFA052",
            borderRadius: 3,
          }}
        >
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic", fontSize: 26, color: "#CFA052", lineHeight: 1.3, margin: 0 }}>
            "Educate. Agitate. Organise."
          </p>
          <p style={{ fontSize: 13, color: "rgba(253,251,247,0.7)", marginTop: 8, marginBottom: 0 }}>
            — Babasaheb Dr. B.R. Ambedkar
          </p>
        </div>
      </div>

      {/* CTA */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          padding: "44px 70px 56px",
          background: "linear-gradient(180deg, transparent 0%, #000B1F 60%)",
          borderTop: "1px solid rgba(207,160,82,0.25)",
        }}
      >
        <p style={{ fontSize: 12, letterSpacing: "0.32em", color: "#E07A5F", textTransform: "uppercase", fontWeight: 600, marginBottom: 12 }}>
          Visit · Read · Sit · Belong
        </p>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: 18 }}>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 36, color: "#CFA052", margin: 0, lineHeight: 1, letterSpacing: "-0.01em", wordBreak: "break-all", flex: 1, minWidth: 0 }}>
            {SITE_URL}
          </p>
          <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontStyle: "italic", color: "rgba(253,251,247,0.7)", margin: 0, textAlign: "right", lineHeight: 1.25, flexShrink: 0 }}>
            Educate<br />Meditate<br />Empower<br />Elevate
          </p>
        </div>
        <p style={{ fontSize: 11, color: "rgba(253,251,247,0.45)", marginTop: 18, marginBottom: 0, fontStyle: "italic", fontFamily: "'Cormorant Garamond', serif" }}>
          Jai Bhim · Namo Buddhāya
        </p>
      </div>
    </div>
  );
}
